import type { AppBase } from 'playcanvas';

/**
 * Fail LOUDLY if a required component system did not register (the engine-only AppBase footgun the
 * canon calls out, arch §1.1: with `AppBase` + manual `componentSystems` a forgotten system is a
 * silent no-render). Call after `app.init(options)` and before `app.start()`.
 */
export function assertSystemsRegistered(app: AppBase, required: readonly string[]): void {
  const registry = app.systems as unknown as Record<string, unknown>;
  const missing = required.filter((name) => registry[name] == null);
  if (missing.length > 0) {
    throw new Error(
      `AppBase component systems not registered: [${missing.join(', ')}]. ` +
        `Add them to AppOptions.componentSystems before app.init()/app.start().`,
    );
  }
}
